<div class="date-filter-wrapper w-full">

  <div class="date-input-wrapper" [class.error]="hasError">
    <!-- Campo de fecha -->
    <input
      type="text"
      class="date-input typography-body-m-regular"
      [value]="inputValue()"
      [placeholder]="config.format ?? 'DD/MM/YYYY'"
      [disabled]="config.disabled || isLoading"
      readonly
      tabindex="-1"
      aria-hidden="true"
      autocomplete="off"
    />

    <input
      type="date"
      class="native-picker-input"
      [value]="nativePickerValue()"
      [max]="config.max"
      [disabled]="config.disabled || isLoading"
      [attr.aria-label]="getTranslatedLabel(config.label)"
      (change)="onNativePickerChange($event)"
    />

    <span class="picker-icon" aria-hidden="true">
      <img src="assets/icons/datepicker.svg" alt="" width="20" height="20" />
    </span>

    <!-- Botón de limpiar -->
    <!-- <button
      type="button"
      *ngIf="config.showClearButton && selectedDateExists()"
      class="clear-button"
      (click)="clearDateRange()"
      [disabled]="config.disabled || isLoading"
      aria-label="Clear date"
    >
      &#x2715;
    </button> -->
  </div>
</div>
